import { render, staticRenderFns } from "./LeftAside.vue?vue&type=template&id=f11c720e"
import script from "./LeftAside.vue?vue&type=script&lang=js"
export * from "./LeftAside.vue?vue&type=script&lang=js"
import style0 from "./LeftAside.vue?vue&type=style&index=0&id=f11c720e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.18.1_vue-template-compiler@2.6.14_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports